function Vision() {
  return (
    <div className="pt-16 px-4 md:px-8 lg:px-16 max-w-5xl mx-auto">
      <h2 className="text-3xl md:text-4xl font-bold mb-6 text-center md:text-left">
        दृष्टी व ध्येय
      </h2>
      <p className="text-gray-700 text-base md:text-lg leading-relaxed">
        श्रद्धा आणि सेवेच्या माध्यमातून समाजात अध्यात्मिक जागृती निर्माण करणे
        <br />
        उद्दिष्टे व ध्येय <br />
        १) भगवान शिवाच्या उपासनेचा प्रसार करणे व धार्मिक श्रद्धा दृढ करणे.
        <br />
        २) मुख्यत्वे महाशिवरात्रीचा वार्षिक महोत्सव साजरा करणे. तसेच राष्ट्रीय
        सण, वार्षिक पूजा, नवरात्रोत्सव, दीपोत्सव, रामनवमी, श्रावण मास उत्सव
        साजरे करणे व भंडारा तसेच महाप्रसाद वितरण व अन्नदानाचे आयोजन करणे. <br />
        ३) सार्वजनिक वाचनालये, अभ्यासिका व अध्यात्मिक सभागृहे निर्माण करणे तसेच
        सार्वजनिक स्वच्छता अभियान राबविणे. <br />
        ४) महिलांना संरक्षण देणे व त्यांच्यावर होणाऱ्या अन्याय व
        अत्याचाराविरुद्ध रितसर कायदेशीर कारवाई करणे. अन्याय निर्मूलनासाठी महिला
        व पुरुषांना संघटित करणे. <br />
        ५) सार्वजनिक मंदिर, मठ, शिवालय व सत्संग केंद्रांना सहाय्य करणे. समाज
        मंदिर, सभागृह व आरोग्यधाम निर्माण करणे, बांधणे व चालविणे. <br />
        ६) निराधार, अपंग, आदिवासी व दुर्लभ घटकांतील मुले तसेच विधवा महिलांना
        आर्थिक सहाय्य करणे. <br />
        ७) सार्वजनिक व धर्मार्थ दवाखाने तसेच आरोग्य केंद्रे चालविणे किंवा
        चालविण्याचा प्रयत्न करणे. सेवानिवृत्त व ज्येष्ठ नागरिकांना आवश्यक त्या
        सोयी-सुविधा उपलब्ध करून देणे. <br />
        ८) सार्वजनिक रुग्णवाहिका सेवा चालविणे, गरजू व गरीब व्यक्तींना औषधोपचार
        मिळवून देणे तसेच वैद्यकीय मदत करणे. <br />
        ९) नैसर्गिक आपत्तीग्रस्त व्यक्तींना मदत व पुनर्वसनासाठी कार्य करणे.
      </p>
    </div>
  );
}

export default Vision;
